module.exports = __webpack_public_path__ + "static/media/flight2.e357843e.svg";